<div class="crm-container" style="position: relative; min-height: 570px;">
  <app-tab-spinner *ngIf="isLoading" [fixed]="false"></app-tab-spinner>
  <app-section-header [optionHeader]="opHeader" [title]="'Service Rates'" />

  <p-popover #opRow><p-listbox [options]="ellipsisOptions"
      (onClick)="this[$event.option.callback] ? this[$event.option.callback]($event) : ellipsisOptionClick($event)"></p-listbox></p-popover><p-popover
    #opHeader><p-listbox [options]="ellipsisHeaderCrudOptions"
      (onClick)="this[$event.option.callback] ? this[$event.option.callback]($event) : ellipsisOptionClick($event)"></p-listbox></p-popover>
  <div class="refresh" *ngIf="!isRefresh">
    <adjudication-limit-section></adjudication-limit-section><system-approval-section></system-approval-section><parts-markup-section></parts-markup-section><extra-mileage-section></extra-mileage-section><rate-schedule-section></rate-schedule-section>
  </div>
</div>